// extracted by mini-css-extract-plugin
module.exports = {"movies-list":"MoviesList_movies-list__1w_Vk"};